import { render, staticRenderFns } from "./dialog-table-delegate.vue?vue&type=template&id=cd93f3bc&scoped=true&"
import script from "./dialog-table-delegate.vue?vue&type=script&lang=js&"
export * from "./dialog-table-delegate.vue?vue&type=script&lang=js&"
import style0 from "./dialog-table-delegate.vue?vue&type=style&index=0&id=cd93f3bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd93f3bc",
  null
  
)

export default component.exports